import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-loading-input',
  templateUrl: './loading-input.component.html',
  styleUrls: ['./loading-input.component.css']
})
export class LoadingInputComponent implements OnInit {
  isDark = false;

  @Input()
  public set dark(isDark: boolean) {
    this.isDark = isDark;
  }

  constructor() {
  }

  ngOnInit(): void {
  }

}
